// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/customer.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/customer.proto.
 */
export const file_v1_customer: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_api_annotations]);

/**
 * @generated from message v1.Customer
 */
export type Customer = Message<"v1.Customer"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 debt = 3;
   */
  debt: number;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: v1.ProfitType profit_type = 5;
   */
  profitType: ProfitType;

  /**
   * @generated from field: int32 sign = 6;
   */
  sign: number;

  /**
   * @generated from field: v1.BonusDtType bonus_dt_type = 7;
   */
  bonusDtType: BonusDtType;

  /**
   * @generated from field: v1.BonusDtType bonus_dt_type_mb = 8;
   */
  bonusDtTypeMb: BonusDtType;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: v1.CommissionType commission_calculation_type = 11;
   */
  commissionCalculationType: CommissionType;

  /**
   * @generated from field: v1.AllowExchangeToCrossCombo allow_exchange_to_cross_combo = 12;
   */
  allowExchangeToCrossCombo: AllowExchangeToCrossCombo;

  /**
   * @generated from field: repeated v1.CustomerBetType customer_bet_types = 13;
   */
  customerBetTypes: CustomerBetType[];

  /**
   * @generated from field: repeated v1.CustomerCommissionAll customer_commission_all = 14;
   */
  customerCommissionAll: CustomerCommissionAll[];

  /**
   * @generated from field: repeated v1.CustomerCommissionForDigits customer_commission_for_digits = 15;
   */
  customerCommissionForDigits: CustomerCommissionForDigits[];

  /**
   * @generated from field: optional int64 telegram_chat_id = 16;
   */
  telegramChatId?: bigint;

  /**
   * @generated from field: optional string telegram_group_title = 17;
   */
  telegramGroupTitle?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp telegram_linked_at = 18;
   */
  telegramLinkedAt?: Timestamp;
};

/**
 * Describes the message v1.Customer.
 * Use `create(CustomerSchema)` to create a new message.
 */
export const CustomerSchema: GenMessage<Customer> = /*@__PURE__*/
  messageDesc(file_v1_customer, 0);

/**
 * @generated from message v1.BetTypeMaster
 */
export type BetTypeMaster = Message<"v1.BetTypeMaster"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string bet_type = 2;
   */
  betType: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message v1.BetTypeMaster.
 * Use `create(BetTypeMasterSchema)` to create a new message.
 */
export const BetTypeMasterSchema: GenMessage<BetTypeMaster> = /*@__PURE__*/
  messageDesc(file_v1_customer, 1);

/**
 * @generated from message v1.CustomerBetType
 */
export type CustomerBetType = Message<"v1.CustomerBetType"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: int32 bet_type_id = 3;
   */
  betTypeId: number;

  /**
   * @generated from field: v1.Region region = 4;
   */
  region: Region;

  /**
   * @generated from field: string username = 5;
   */
  username: string;

  /**
   * @generated from field: double share_rate = 6;
   */
  shareRate: number;

  /**
   * @generated from field: double payout_rate = 7;
   */
  payoutRate: number;

  /**
   * @generated from field: double commission_rate = 8;
   */
  commissionRate: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Embedded bet type master data
   *
   * @generated from field: string bet_type = 11;
   */
  betType: string;

  /**
   * @generated from field: string label = 12;
   */
  label: string;

  /**
   * @generated from field: string description = 13;
   */
  description: string;
};

/**
 * Describes the message v1.CustomerBetType.
 * Use `create(CustomerBetTypeSchema)` to create a new message.
 */
export const CustomerBetTypeSchema: GenMessage<CustomerBetType> = /*@__PURE__*/
  messageDesc(file_v1_customer, 2);

/**
 * @generated from message v1.CustomerCommissionAll
 */
export type CustomerCommissionAll = Message<"v1.CustomerCommissionAll"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: v1.Region region = 3;
   */
  region: Region;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: double commission_rate = 5;
   */
  commissionRate: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message v1.CustomerCommissionAll.
 * Use `create(CustomerCommissionAllSchema)` to create a new message.
 */
export const CustomerCommissionAllSchema: GenMessage<CustomerCommissionAll> = /*@__PURE__*/
  messageDesc(file_v1_customer, 3);

/**
 * @generated from message v1.CustomerCommissionForDigits
 */
export type CustomerCommissionForDigits = Message<"v1.CustomerCommissionForDigits"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: v1.Region region = 3;
   */
  region: Region;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: double commission_two_digits = 5;
   */
  commissionTwoDigits: number;

  /**
   * @generated from field: double commission_three_digits = 6;
   */
  commissionThreeDigits: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message v1.CustomerCommissionForDigits.
 * Use `create(CustomerCommissionForDigitsSchema)` to create a new message.
 */
export const CustomerCommissionForDigitsSchema: GenMessage<CustomerCommissionForDigits> = /*@__PURE__*/
  messageDesc(file_v1_customer, 4);

/**
 * @generated from message v1.CreateCustomerRequest
 */
export type CreateCustomerRequest = Message<"v1.CreateCustomerRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: v1.ProfitType profit_type = 2;
   */
  profitType: ProfitType;

  /**
   * @generated from field: int32 sign = 3;
   */
  sign: number;

  /**
   * @generated from field: v1.BonusDtType bonus_dt_type = 4;
   */
  bonusDtType: BonusDtType;

  /**
   * @generated from field: v1.BonusDtType bonus_dt_type_mb = 5;
   */
  bonusDtTypeMb: BonusDtType;

  /**
   * @generated from field: v1.CommissionType commission_calculation_type = 6;
   */
  commissionCalculationType: CommissionType;

  /**
   * @generated from field: v1.AllowExchangeToCrossCombo allow_exchange_to_cross_combo = 7;
   */
  allowExchangeToCrossCombo: AllowExchangeToCrossCombo;

  /**
   * @generated from field: repeated v1.CustomerBetTypeInput customer_bet_types = 8;
   */
  customerBetTypes: CustomerBetTypeInput[];

  /**
   * @generated from field: repeated v1.CustomerCommissionAllInput customer_commission_all = 9;
   */
  customerCommissionAll: CustomerCommissionAllInput[];

  /**
   * @generated from field: repeated v1.CustomerCommissionForDigitsInput customer_commission_for_digits = 10;
   */
  customerCommissionForDigits: CustomerCommissionForDigitsInput[];
};

/**
 * Describes the message v1.CreateCustomerRequest.
 * Use `create(CreateCustomerRequestSchema)` to create a new message.
 */
export const CreateCustomerRequestSchema: GenMessage<CreateCustomerRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 5);

/**
 * @generated from message v1.CreateCustomerResponse
 */
export type CreateCustomerResponse = Message<"v1.CreateCustomerResponse"> & {
  /**
   * @generated from field: v1.Customer customer = 1;
   */
  customer?: Customer;
};

/**
 * Describes the message v1.CreateCustomerResponse.
 * Use `create(CreateCustomerResponseSchema)` to create a new message.
 */
export const CreateCustomerResponseSchema: GenMessage<CreateCustomerResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 6);

/**
 * @generated from message v1.UpdateCustomerRequest
 */
export type UpdateCustomerRequest = Message<"v1.UpdateCustomerRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: v1.ProfitType profit_type = 3;
   */
  profitType: ProfitType;

  /**
   * @generated from field: int32 sign = 4;
   */
  sign: number;

  /**
   * @generated from field: v1.BonusDtType bonus_dt_type = 5;
   */
  bonusDtType: BonusDtType;

  /**
   * @generated from field: v1.BonusDtType bonus_dt_type_mb = 6;
   */
  bonusDtTypeMb: BonusDtType;

  /**
   * @generated from field: v1.CommissionType commission_calculation_type = 7;
   */
  commissionCalculationType: CommissionType;

  /**
   * @generated from field: v1.AllowExchangeToCrossCombo allow_exchange_to_cross_combo = 8;
   */
  allowExchangeToCrossCombo: AllowExchangeToCrossCombo;

  /**
   * @generated from field: repeated v1.CustomerBetTypeInput customer_bet_types = 9;
   */
  customerBetTypes: CustomerBetTypeInput[];

  /**
   * @generated from field: repeated v1.CustomerCommissionAllInput customer_commission_all = 10;
   */
  customerCommissionAll: CustomerCommissionAllInput[];

  /**
   * @generated from field: repeated v1.CustomerCommissionForDigitsInput customer_commission_for_digits = 11;
   */
  customerCommissionForDigits: CustomerCommissionForDigitsInput[];
};

/**
 * Describes the message v1.UpdateCustomerRequest.
 * Use `create(UpdateCustomerRequestSchema)` to create a new message.
 */
export const UpdateCustomerRequestSchema: GenMessage<UpdateCustomerRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 7);

/**
 * @generated from message v1.UpdateCustomerResponse
 */
export type UpdateCustomerResponse = Message<"v1.UpdateCustomerResponse"> & {
  /**
   * @generated from field: v1.Customer customer = 1;
   */
  customer?: Customer;
};

/**
 * Describes the message v1.UpdateCustomerResponse.
 * Use `create(UpdateCustomerResponseSchema)` to create a new message.
 */
export const UpdateCustomerResponseSchema: GenMessage<UpdateCustomerResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 8);

/**
 * @generated from message v1.GetCustomerRequest
 */
export type GetCustomerRequest = Message<"v1.GetCustomerRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.GetCustomerRequest.
 * Use `create(GetCustomerRequestSchema)` to create a new message.
 */
export const GetCustomerRequestSchema: GenMessage<GetCustomerRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 9);

/**
 * @generated from message v1.GetCustomerResponse
 */
export type GetCustomerResponse = Message<"v1.GetCustomerResponse"> & {
  /**
   * @generated from field: v1.Customer customer = 1;
   */
  customer?: Customer;
};

/**
 * Describes the message v1.GetCustomerResponse.
 * Use `create(GetCustomerResponseSchema)` to create a new message.
 */
export const GetCustomerResponseSchema: GenMessage<GetCustomerResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 10);

/**
 * Add pagination fields if needed
 *
 * @generated from message v1.ListCustomersRequest
 */
export type ListCustomersRequest = Message<"v1.ListCustomersRequest"> & {
};

/**
 * Describes the message v1.ListCustomersRequest.
 * Use `create(ListCustomersRequestSchema)` to create a new message.
 */
export const ListCustomersRequestSchema: GenMessage<ListCustomersRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 11);

/**
 * @generated from message v1.ListCustomersResponse
 */
export type ListCustomersResponse = Message<"v1.ListCustomersResponse"> & {
  /**
   * @generated from field: repeated v1.Customer customers = 1;
   */
  customers: Customer[];
};

/**
 * Describes the message v1.ListCustomersResponse.
 * Use `create(ListCustomersResponseSchema)` to create a new message.
 */
export const ListCustomersResponseSchema: GenMessage<ListCustomersResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 12);

/**
 * @generated from message v1.GetCustomerDebtsRequest
 */
export type GetCustomerDebtsRequest = Message<"v1.GetCustomerDebtsRequest"> & {
  /**
   * @generated from field: repeated int32 customer_ids = 1;
   */
  customerIds: number[];
};

/**
 * Describes the message v1.GetCustomerDebtsRequest.
 * Use `create(GetCustomerDebtsRequestSchema)` to create a new message.
 */
export const GetCustomerDebtsRequestSchema: GenMessage<GetCustomerDebtsRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 13);

/**
 * @generated from message v1.CustomerDebt
 */
export type CustomerDebt = Message<"v1.CustomerDebt"> & {
  /**
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;

  /**
   * @generated from field: int32 debt = 2;
   */
  debt: number;
};

/**
 * Describes the message v1.CustomerDebt.
 * Use `create(CustomerDebtSchema)` to create a new message.
 */
export const CustomerDebtSchema: GenMessage<CustomerDebt> = /*@__PURE__*/
  messageDesc(file_v1_customer, 14);

/**
 * @generated from message v1.GetCustomerDebtsResponse
 */
export type GetCustomerDebtsResponse = Message<"v1.GetCustomerDebtsResponse"> & {
  /**
   * @generated from field: repeated v1.CustomerDebt customer_debts = 1;
   */
  customerDebts: CustomerDebt[];
};

/**
 * Describes the message v1.GetCustomerDebtsResponse.
 * Use `create(GetCustomerDebtsResponseSchema)` to create a new message.
 */
export const GetCustomerDebtsResponseSchema: GenMessage<GetCustomerDebtsResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 15);

/**
 * @generated from message v1.UpdateCustomerDebtRequest
 */
export type UpdateCustomerDebtRequest = Message<"v1.UpdateCustomerDebtRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 debt = 2;
   */
  debt: number;
};

/**
 * Describes the message v1.UpdateCustomerDebtRequest.
 * Use `create(UpdateCustomerDebtRequestSchema)` to create a new message.
 */
export const UpdateCustomerDebtRequestSchema: GenMessage<UpdateCustomerDebtRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 16);

/**
 * @generated from message v1.UpdateCustomerDebtResponse
 */
export type UpdateCustomerDebtResponse = Message<"v1.UpdateCustomerDebtResponse"> & {
  /**
   * @generated from field: v1.Customer customer = 1;
   */
  customer?: Customer;
};

/**
 * Describes the message v1.UpdateCustomerDebtResponse.
 * Use `create(UpdateCustomerDebtResponseSchema)` to create a new message.
 */
export const UpdateCustomerDebtResponseSchema: GenMessage<UpdateCustomerDebtResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 17);

/**
 * @generated from message v1.UpdateCustomersDebtRequest
 */
export type UpdateCustomersDebtRequest = Message<"v1.UpdateCustomersDebtRequest"> & {
  /**
   * @generated from field: repeated v1.CustomerDebtUpdate data = 1;
   */
  data: CustomerDebtUpdate[];
};

/**
 * Describes the message v1.UpdateCustomersDebtRequest.
 * Use `create(UpdateCustomersDebtRequestSchema)` to create a new message.
 */
export const UpdateCustomersDebtRequestSchema: GenMessage<UpdateCustomersDebtRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 18);

/**
 * @generated from message v1.CustomerDebtUpdate
 */
export type CustomerDebtUpdate = Message<"v1.CustomerDebtUpdate"> & {
  /**
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;

  /**
   * @generated from field: int32 debt = 2;
   */
  debt: number;
};

/**
 * Describes the message v1.CustomerDebtUpdate.
 * Use `create(CustomerDebtUpdateSchema)` to create a new message.
 */
export const CustomerDebtUpdateSchema: GenMessage<CustomerDebtUpdate> = /*@__PURE__*/
  messageDesc(file_v1_customer, 19);

/**
 * @generated from message v1.UpdateCustomersDebtResponse
 */
export type UpdateCustomersDebtResponse = Message<"v1.UpdateCustomersDebtResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message v1.UpdateCustomersDebtResponse.
 * Use `create(UpdateCustomersDebtResponseSchema)` to create a new message.
 */
export const UpdateCustomersDebtResponseSchema: GenMessage<UpdateCustomersDebtResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 20);

/**
 * @generated from message v1.DeleteCustomerRequest
 */
export type DeleteCustomerRequest = Message<"v1.DeleteCustomerRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.DeleteCustomerRequest.
 * Use `create(DeleteCustomerRequestSchema)` to create a new message.
 */
export const DeleteCustomerRequestSchema: GenMessage<DeleteCustomerRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer, 21);

/**
 * @generated from message v1.DeleteCustomerResponse
 */
export type DeleteCustomerResponse = Message<"v1.DeleteCustomerResponse"> & {
  /**
   * @generated from field: repeated v1.Customer customers = 1;
   */
  customers: Customer[];
};

/**
 * Describes the message v1.DeleteCustomerResponse.
 * Use `create(DeleteCustomerResponseSchema)` to create a new message.
 */
export const DeleteCustomerResponseSchema: GenMessage<DeleteCustomerResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer, 22);

/**
 * @generated from message v1.CustomerBetTypeInput
 */
export type CustomerBetTypeInput = Message<"v1.CustomerBetTypeInput"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 bet_type_id = 2;
   */
  betTypeId: number;

  /**
   * @generated from field: v1.Region region = 3;
   */
  region: Region;

  /**
   * @generated from field: double share_rate = 4;
   */
  shareRate: number;

  /**
   * @generated from field: double payout_rate = 5;
   */
  payoutRate: number;

  /**
   * @generated from field: double commission_rate = 6;
   */
  commissionRate: number;
};

/**
 * Describes the message v1.CustomerBetTypeInput.
 * Use `create(CustomerBetTypeInputSchema)` to create a new message.
 */
export const CustomerBetTypeInputSchema: GenMessage<CustomerBetTypeInput> = /*@__PURE__*/
  messageDesc(file_v1_customer, 23);

/**
 * @generated from message v1.CustomerCommissionAllInput
 */
export type CustomerCommissionAllInput = Message<"v1.CustomerCommissionAllInput"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: v1.Region region = 2;
   */
  region: Region;

  /**
   * @generated from field: double commission_rate = 3;
   */
  commissionRate: number;
};

/**
 * Describes the message v1.CustomerCommissionAllInput.
 * Use `create(CustomerCommissionAllInputSchema)` to create a new message.
 */
export const CustomerCommissionAllInputSchema: GenMessage<CustomerCommissionAllInput> = /*@__PURE__*/
  messageDesc(file_v1_customer, 24);

/**
 * @generated from message v1.CustomerCommissionForDigitsInput
 */
export type CustomerCommissionForDigitsInput = Message<"v1.CustomerCommissionForDigitsInput"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: v1.Region region = 2;
   */
  region: Region;

  /**
   * @generated from field: double commission_two_digits = 3;
   */
  commissionTwoDigits: number;

  /**
   * @generated from field: double commission_three_digits = 4;
   */
  commissionThreeDigits: number;
};

/**
 * Describes the message v1.CustomerCommissionForDigitsInput.
 * Use `create(CustomerCommissionForDigitsInputSchema)` to create a new message.
 */
export const CustomerCommissionForDigitsInputSchema: GenMessage<CustomerCommissionForDigitsInput> = /*@__PURE__*/
  messageDesc(file_v1_customer, 25);

/**
 * @generated from enum v1.ProfitType
 */
export enum ProfitType {
  /**
   * @generated from enum value: PROFIT_TYPE_SEPARATE = 0;
   */
  SEPARATE = 0,

  /**
   * @generated from enum value: PROFIT_TYPE_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: PROFIT_TYPE_DIGITS = 2;
   */
  DIGITS = 2,
}

/**
 * Describes the enum v1.ProfitType.
 */
export const ProfitTypeSchema: GenEnum<ProfitType> = /*@__PURE__*/
  enumDesc(file_v1_customer, 0);

/**
 * @generated from enum v1.CommissionType
 */
export enum CommissionType {
  /**
   * @generated from enum value: COMMISSION_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: COMMISSION_TYPE_ON_PROFIT = 1;
   */
  ON_PROFIT = 1,

  /**
   * @generated from enum value: COMMISSION_TYPE_ALWAYS = 2;
   */
  ALWAYS = 2,
}

/**
 * Describes the enum v1.CommissionType.
 */
export const CommissionTypeSchema: GenEnum<CommissionType> = /*@__PURE__*/
  enumDesc(file_v1_customer, 1);

/**
 * @generated from enum v1.AllowExchangeToCrossCombo
 */
export enum AllowExchangeToCrossCombo {
  /**
   * @generated from enum value: ALLOW_EXCHANGE_TO_CROSS_COMBO_DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * @generated from enum value: ALLOW_EXCHANGE_TO_CROSS_COMBO_YES = 1;
   */
  YES = 1,

  /**
   * @generated from enum value: ALLOW_EXCHANGE_TO_CROSS_COMBO_NO = 2;
   */
  NO = 2,
}

/**
 * Describes the enum v1.AllowExchangeToCrossCombo.
 */
export const AllowExchangeToCrossComboSchema: GenEnum<AllowExchangeToCrossCombo> = /*@__PURE__*/
  enumDesc(file_v1_customer, 2);

/**
 * @generated from enum v1.BonusDtType
 */
export enum BonusDtType {
  /**
   * @generated from enum value: BONUS_DT_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: BONUS_DT_TYPE_BONUS = 1;
   */
  BONUS = 1,
}

/**
 * Describes the enum v1.BonusDtType.
 */
export const BonusDtTypeSchema: GenEnum<BonusDtType> = /*@__PURE__*/
  enumDesc(file_v1_customer, 3);

/**
 * @generated from enum v1.Region
 */
export enum Region {
  /**
   * @generated from enum value: REGION_MN = 0;
   */
  MN = 0,

  /**
   * @generated from enum value: REGION_MT = 1;
   */
  MT = 1,

  /**
   * @generated from enum value: REGION_MB = 2;
   */
  MB = 2,
}

/**
 * Describes the enum v1.Region.
 */
export const RegionSchema: GenEnum<Region> = /*@__PURE__*/
  enumDesc(file_v1_customer, 4);

/**
 * @generated from service v1.CustomerService
 */
export const CustomerService: GenService<{
  /**
   * @generated from rpc v1.CustomerService.CreateCustomer
   */
  createCustomer: {
    methodKind: "unary";
    input: typeof CreateCustomerRequestSchema;
    output: typeof CreateCustomerResponseSchema;
  },
  /**
   * @generated from rpc v1.CustomerService.UpdateCustomer
   */
  updateCustomer: {
    methodKind: "unary";
    input: typeof UpdateCustomerRequestSchema;
    output: typeof UpdateCustomerResponseSchema;
  },
  /**
   * @generated from rpc v1.CustomerService.GetCustomer
   */
  getCustomer: {
    methodKind: "unary";
    input: typeof GetCustomerRequestSchema;
    output: typeof GetCustomerResponseSchema;
  },
  /**
   * @generated from rpc v1.CustomerService.ListCustomers
   */
  listCustomers: {
    methodKind: "unary";
    input: typeof ListCustomersRequestSchema;
    output: typeof ListCustomersResponseSchema;
  },
  /**
   * @generated from rpc v1.CustomerService.GetCustomerDebts
   */
  getCustomerDebts: {
    methodKind: "unary";
    input: typeof GetCustomerDebtsRequestSchema;
    output: typeof GetCustomerDebtsResponseSchema;
  },
  /**
   * @generated from rpc v1.CustomerService.UpdateCustomerDebt
   */
  updateCustomerDebt: {
    methodKind: "unary";
    input: typeof UpdateCustomerDebtRequestSchema;
    output: typeof UpdateCustomerDebtResponseSchema;
  },
  /**
   * @generated from rpc v1.CustomerService.UpdateCustomersDebt
   */
  updateCustomersDebt: {
    methodKind: "unary";
    input: typeof UpdateCustomersDebtRequestSchema;
    output: typeof UpdateCustomersDebtResponseSchema;
  },
  /**
   * @generated from rpc v1.CustomerService.DeleteCustomer
   */
  deleteCustomer: {
    methodKind: "unary";
    input: typeof DeleteCustomerRequestSchema;
    output: typeof DeleteCustomerResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_customer, 0);

